
















import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  纯进度模式
 * @desc 只做进度条展示。
 */
@Component
export default class ProcessExample extends Vue {
}
